import { css } from "@emotion/react";
import bgLanding from "../../assets/bg.jpg";

export const styLanding = css`
  background-color: #f9f9f9;
  background-image: url(${bgLanding});
  background-size: cover;
  background-position: center top;
  height: 100vh;
  margin: 0 auto;
  max-width: 720px;

  color: #6b6445;
`;

export const styLandingWrapper = css`
  padding: 30px 20px 75px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const styLandingInfo = css`
  p {
    margin: 0;
  }

  h1 {
    font-family: "Dancing Script", cursive;
    font-weight: 700;
    margin: 0;
    font-size: 36px;

    @media (min-width: 350px) {
      font-size: 52px;
    }
  }
`;

export const styLandingAction = (isOpen?: boolean) => css`
  button {
    margin-top: 28px;

    width: 180px;
    padding: 12px;

    @media (min-width: 350px) {
      margin-top: 32px;
      width: 240px;
      padding: 16px;
    }
    ${isOpen && `color:transparent; background: transparent`}
  }
`;

export const styLandingGuest = css`
  p {
    margin: 0;
  }

  h4 {
    margin: 8px 0 0;
  }
`;

export const styTitle = css`
  margin-bottom: 20px;
`;

export const styContent = css`
  margin-bottom: 20px;
`;

export const styName = css`
  margin-bottom: 10px;
`;

export const styButton = css`
  background-color: #e91e63;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #d81b60;
  }
`;
